import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Base query setup for RTK Query
const baseQuery = fetchBaseQuery({
  baseUrl: 'https://liveapi-main-in.nuqiwealth.com/',
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('authToken');
    if (token && token !== 'undefined') {
      headers.set('authorization', `Bearer ${token}`);
    }
    headers.set('Content-Type', 'application/json');
    return headers;
  },
});

// Base API slice that can be extended
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: ['Auth', 'User', 'KycRecords'],
  endpoints: () => ({
  }),
});
